import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import pigFarmImage from '../../assets/images/pig-farm.png';

const HeroSection = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${pigFarmImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        textAlign: 'center',
        padding: 2,
      }}
    >
      <Typography variant="h2" gutterBottom>
        Revolutionizing Pig Farming with AI
      </Typography>
      <Typography variant="h5" gutterBottom>
        Accurate and real-time pig counting to optimize your farm operations.
      </Typography>
      <Button variant="contained" color="primary" size="large">
        Learn More
      </Button>
    </Box>
  );
};

export default HeroSection;